import React, { useState, useEffect } from 'react';
import Section from '../components/Section';
import { MdSportsSoccer } from 'react-icons/md';

const Sports = () => {
  const [headerHeight, setHeaderHeight] = useState();

  useEffect(() => {
    const header = document.getElementById('header');
    if (header) {
      setHeaderHeight(header.offsetHeight);
    }
  }, []);

  const language = 'es';

  const section = {
    section: 'Deportes',
    sectionTitle: {
      es: 'Deportes',
      it: 'Sport',
    },
    icon: <MdSportsSoccer />
  };
  return (
    <div>
      <Section
        sectionTitle={section.sectionTitle[language]}
        section={section.section}
        isOnSection={true}
        headerHeight={headerHeight}
        icon={section.icon}
      />
    </div>
  );
};

export default Sports;